import * as locationsModule from '@/store/locations/locationsModule'

export const state = Object.assign({}, locationsModule.defaults())

export default {
  namespaced: true,
  state,
  mutations: locationsModule.mutations,
  actions: locationsModule.actions,
  getters: locationsModule.getters
}



// WEBPACK FOOTER //
// ./src/store/administration/partners/partnerLocationsModule.js